import { HotmartRum } from '@hot-observability-js/react'

export default function setupSentry() {
  const release = process.env.DRONE_COMMIT_SHA || ''
  HotmartRum.init({
    dsn: process.env.SENTRY_DSN_HOST,
    release,
    environment: process.env.NODE_ENV,
    disableCaptureConsoleIntegration: true
  })
}
